export default __webpack_public_path__ + "static/media/fail.8ff17584.png";